import { BASE_URL } from "./ServerEndpointController";
import axios from 'axios';

const EXCURSIONS_ENDPOINT = `${BASE_URL}/excursions`;
export async function getExcursionsData() {
    try {
        const response = await axios.get(`${EXCURSIONS_ENDPOINT}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching excursions data:', error);
    }
};

export async function getUsers(id) {
    try {
        const response = await axios.get(`${EXCURSIONS_ENDPOINT}/` + id + `/users`);
        return response.data;
    } catch (error) {
        console.error('Error fetching users data:', error);
    }
}

export async function getSamples(id) {
    try {
        const response = await axios.get(`${EXCURSIONS_ENDPOINT}/` + id + `/samples`);
        return response.data;
    } catch (error) {
        console.error('Error fetching samples data:', error);
    }
}